import { css, keyframes } from '@emotion/css'
import { spacing, fontSize, fontWeight, colors, accessiblyHidden, zIndex } from '@offerzen/pinata-shame'

// animation
const slideInUp = keyframes({
  from: {
    transform: 'translate3d(0, 100%, 0)',
    visibility: 'visible',
  },

  to: {
    transform: 'translate3d(0, 0, 0)',
  },
})

const styles = {
  container: css({
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
    padding: spacing.medium,
    background: colors.white,
    animationName: slideInUp,
    animationDuration: '0.5s',
    animationTimingFunction: 'ease-in',
    zIndex: zIndex.level10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),

  text: css({
    fontSize: fontSize.small,
    color: colors.oxfordBlue,
    marginRight: spacing.medium,
  }),

  link: css({
    color: 'inherit',
    fontWeight: fontWeight.semiBold,
  }),

  hiddenSuccessMessage: css(accessiblyHidden),
}

export default styles
